export const matches = [
    {
        id: 1,
        homeTeam: "Atalanta",
        awayTeam: "Bayern München",
        homeLogo: "/Images/Atalanta.png",
        awayLogo: "/Images/bayernLogo.png",
        homeScore: 1,
        awayScore: 4,
        date: "18 / Mar / 2026",
        stadium: "Atleti Azzurri",
        status: "Finished",
        img:"/Images/UCL.jpg"
    },

    {
        id: 2,
        homeTeam: "Bayern München",
        awayTeam: "Union Berlin",
        homeLogo: "/Images/bayernLogo.png",
        awayLogo: "/Images/Union-Berlin.png",
        homeScore: 4,
        awayScore: 0,
        date: "21 / Mar / 2026",
        stadium: "Allianz Arena",
        status: "Finished",
        img:"/Images/bundes.png"
    },

    {
        id: 3,
        homeTeam: "SC Freiburg",
        awayTeam: "Bayern München",
        homeLogo: "/Images/Freiburg.png",
        awayLogo: "/Images/bayernLogo.png",
        homeScore: 2,
        awayScore: 3,
        date: "4 / Apr / 2026",
        stadium: "Europa-Park Stadion",
        status: "Finished",
        img:"/Images/bundes.png"
    },

    {
        id: 4,
        homeTeam: "ST.Pauli",
        awayTeam: "Bayern München",
        homeLogo: "/Images/st-pauli.png",
        awayLogo: "/Images/bayernLogo.png",
        homeScore: 0,
        awayScore: 5,
        date: "11 / Apr / 2026",
        stadium: "Millerntor-Stadion",
        status: "Finished",
        img:"/Images/bundes.png"
    },

    {
        id: 5,
        homeTeam: "Bayern München",
        awayTeam: "Real Madrid",
        homeLogo: "/Images/bayernLogo.png",
        awayLogo: "/Images/maridLogo2.png",
        homeScore: "-",
        awayScore: "-",
        date: "15 / Apr / 2026",
        stadium: "Allianz Arena",
        status: "Upcoming",
        img:"/Images/UCL.jpg"
    },

    {
        id: 6,
        homeTeam: "Bayern München",
        awayTeam: "Stuttgart",
        homeLogo: "/Images/bayernLogo.png",
        awayLogo: "/Images/Stuttgart3.png",
        homeScore: "-",
        awayScore: "-",
        date: "19 / Apr / 2026",
        stadium: "Allianz Arena",
        status: "Upcoming",
        img:"/Images/bundes.png"
    },

    {
        id: 7,
        homeTeam: "Bayer-04-Leverkusen",
        awayTeam: "Bayern München",
        homeLogo: "/Images/Bayer-04-Leverkusen1.png",
        awayLogo: "/Images/bayernLogo.png",
        homeScore: "-",
        awayScore: "-",
        date: "22 / Apr / 2026",
        stadium: "BayArena",
        status: "Upcoming",
        img:"/Images/pokal3.png"
    },

]